<div class="input-group">
  <input type="text" class="form-control" [(ngModel)]="value" (ngModelChange)="valueChanged($event)" placeholder="{{ placeholder | translate }}">
  <button [hidden]="value.length === 0" type="button" class="btn bg-transparent" style="" (click)="clear()">
    <wsb-ui-icon icon="faTimes"></wsb-ui-icon>
  </button>
  <div class="input-group-append">
    <button class="btn btn-outline-secondary search-button">
      <wsb-ui-icon icon="faSearch"></wsb-ui-icon>
    </button>
  </div>
</div>
